// extracted by mini-css-extract-plugin
module.exports = {"leftBox":"AddGasModal-module_leftBox_9dcbc","title":"AddGasModal-module_title_f9106","textArea":"AddGasModal-module_textArea_58d67"};